var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "a-carousel",
      class: {
        "pagination-outside": _vm.placePaginationOutside,
        "arrows-outside": _vm.placeArrowsOutside,
      },
    },
    [
      _vm.carouselIsRegistered
        ? [
            _vm.placeArrowsOutside && !_vm.hideArrows
              ? _c("div", { staticClass: "swiper-arrows" }, [
                  _c(
                    "div",
                    {
                      staticClass: "swiper-arrow swiper-button-prev",
                      on: {
                        click: function ($event) {
                          return _vm.runSwiperFunc("slidePrev")
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "icon-container" },
                        [_c("ChevronLeft")],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "swiper-arrow swiper-button-next",
                      on: {
                        click: function ($event) {
                          return _vm.runSwiperFunc("slideNext")
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "icon-container" },
                        [_c("ChevronRight")],
                        1
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "swiper",
              {
                key: _vm.swiperKey,
                ref: "swiper",
                attrs: { options: _vm.carouselOptions },
              },
              [
                _vm._t("default"),
                _vm._v(" "),
                !_vm.hidePagination
                  ? _c("div", {
                      staticClass: "swiper-pagination",
                      attrs: { slot: "pagination" },
                      slot: "pagination",
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.placeArrowsOutside && !_vm.hideArrows
                  ? [
                      _c(
                        "div",
                        {
                          staticClass: "swiper-arrow swiper-button-prev",
                          attrs: { slot: "button-prev" },
                          slot: "button-prev",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "icon-container" },
                            [_c("ChevronLeft")],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "swiper-arrow swiper-button-next",
                          attrs: { slot: "button-next" },
                          slot: "button-next",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "icon-container" },
                            [_c("ChevronRight")],
                            1
                          ),
                        ]
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]
        : _c(
            "div",
            { staticClass: "ssr-mode swiper-container" },
            [_vm._t("default")],
            2
          ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }